module.exports = __webpack_public_path__ + "img/auth-bg-1.bc403019.jpg";